import { KollelFolderStatus } from '@/models/in/KollelFolderDtoIn';

/** Colour of the status dot in the folders lists, matching the palette kollelStatus.ts uses. */
export const getKollelFolderStatusColor = (status: KollelFolderStatus): string => {
  if (status === KollelFolderStatus.Approved) return 'var(--icon-status-6)';
  if (status === KollelFolderStatus.Rejected) return 'var(--icon-status-4)';
  if (status === KollelFolderStatus.Cancelled) return 'var(--icon-status-4)';
  return 'var(--icon-status-1)';
};

export const getKollelFolderStatusLabelKey = (status: KollelFolderStatus): string => `kollels.folderStatus.${status}`;
